export const dailyUsageChartTypeConstants = {
    NONE: "NONE",
    USAGE: "USAGE",
    GENERATION: "GENERATION",
    COST: "COST",
    NET_ENERGY: "NET_ENERGY",
    DEMAND: "DEMAND",
    CONSUMPTION: "CONSUMPTION",
    EXPORT: "EXPORT"
}